import AppPill from './Pill.vue';
import AppPillGroup from './PillGroup.vue';

export default {
    AppPill,
    AppPillGroup,
}
